class EhaProductEdit {
  constructor(section) {
    this.section = section;
    this.tabs = [...section.querySelectorAll('[role="tab"]')];
    this.panels = [...section.querySelectorAll('[role="tabpanel"]')];

    if (this.tabs.length < 2 || this.panels.length !== this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab, false));
      tab.addEventListener('keydown', (event) => this.onKeydown(event));
    });
  }

  select(tab, moveFocus) {
    const panelId = tab.getAttribute('aria-controls');

    this.tabs.forEach((candidate) => {
      const selected = candidate === tab;
      candidate.setAttribute('aria-selected', String(selected));
      candidate.tabIndex = selected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });

    if (moveFocus) tab.focus();
  }

  onKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (nextIndex === currentIndex) return;

    event.preventDefault();
    this.select(this.tabs[nextIndex], true);
  }
}

const initializeProductEdits = (root = document) => {
  root.querySelectorAll('[data-eha-product-edit]').forEach((section) => {
    if (section.dataset.ehaProductEditReady === 'true') return;
    section.dataset.ehaProductEditReady = 'true';
    new EhaProductEdit(section);
  });
};

initializeProductEdits();

document.addEventListener('shopify:section:load', (event) => initializeProductEdits(event.target));
